
import './App.css';
import Allrouts from './components/Allrouts';
import Nav from './components/Nav';

function App() {
  return (
    <div className="App">
      <Nav/>
      <Allrouts/>
    </div>
  );
}

export default App;
